export default __webpack_public_path__ + "static/media/cancel-icon.537a7192.svg";